/* Own-store product IDs only. No history is read or recorded without consent. */
(function () {
  'use strict';
  var DTC = window.DTC;
  if (!DTC || DTC.discovery) return;
  var key = 'dtc-recent-products-v1';
  var ttl = 7 * 24 * 60 * 60 * 1000;
  var privacyPromise;

  function privacy() {
    if (window.Shopify && Shopify.customerPrivacy) return Promise.resolve(Shopify.customerPrivacy);
    if (!privacyPromise) privacyPromise = new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () { finish(null); }, 3000);
      function finish(api) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(api);
      }
      if (!window.Shopify || !Shopify.loadFeatures) return finish(null);
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        finish(error ? null : Shopify.customerPrivacy);
      });
    });
    return privacyPromise;
  }
  function allowed(api) {
    try { return !!(api && api.analyticsProcessingAllowed() && api.marketingAllowed()); }
    catch (_) { return false; }
  }
  function clear() { try { localStorage.removeItem(key); } catch (_) { /* Storage can be unavailable. */ } }
  function read(api) {
    if (!allowed(api)) { clear(); return []; }
    try {
      var history = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(history)) return [];
      return history.filter(function (p) {
        return p && Number.isSafeInteger(p.id) && p.id > 0 && p.at > Date.now() - ttl && p.at <= Date.now();
      }).slice(0, 12);
    } catch (_) { return []; }
  }
  DTC.discovery = {
    recent: function () { return privacy().then(function (api) { return read(api).map(function (p) { return p.id; }); }); }
  };
  DTC.register('discovery', {
    init: function (root) {
      var active = true;
      var id = Number(root.getAttribute('data-product-id'));
      function record() {
        privacy().then(function (api) {
          if (!active || !id) return;
          var history = read(api);
          if (!allowed(api)) return;
          history = [{ id: id, at: Date.now() }].concat(history.filter(function (p) { return p.id !== id; })).slice(0, 12);
          try { localStorage.setItem(key, JSON.stringify(history)); } catch (_) { /* Optional enhancement. */ }
        });
      }
      record();
      var off = DTC.on(document, 'visitorConsentCollected', record);
      return function () { active = false; off(); };
    }
  });
}());
